import * as store from 'store'
import { get } from 'svelte/store';

export const ajax = async (action, data = {}, type = 'POST') => {
    return await jQuery.ajax({
        url: get(store.ajaxurl),
        type: type,
        data: {
            action,
            ... data    
        }
    });
}

export const menuItemClick = async (item) => {
    switch (item.type) {
        case 'link':
            item.url.indexOf('://') === -1 
                ? 'http://' + item.url
                : item.url
            
            window.open(item.url, '_blank')
            break;

        case 'email':
            window.location.href =  'mailto:' + item.email;
            break;

        default:                
            showMenu.set(false)
            showIntegration.set(true)
            integration.set(item)
            break;
    }
}